module.exports = __webpack_public_path__ + "static/Bäckerbild 1-61b85d03a1cfefca3e5a32be687cc98b.jpg";